import { withValidation, withError } from '@bingads-webui-react/validation';
import { TextField } from '@bingads-webui-react/fabric-control';

export const ValidatedTextField = withError(withValidation(TextField));
